import type { TruncationMode } from '../../../../../typography/text-ellipsis/TextEllipsis.js';
import {
  charsFontWidth12pixelsSize500Map,
  charsFontWidth16pixelsSize500Map,
} from '../../../../core/components/text-ellipsis/chars-font-width-map.js';
import { truncateString } from '../../../../core/components/text-ellipsis/truncate-string.js';
import { CanvasTextAreaProps } from '../../../types/canvas-text-area.js';

export const defineTextToRender = (
  name: string,
  truncationMode: TruncationMode,
  textArea: CanvasTextAreaProps,
  contentType: 'value' | 'label' = 'label',
) => {
  const fontWidthMap =
    contentType === 'label'
      ? charsFontWidth12pixelsSize500Map
      : charsFontWidth16pixelsSize500Map;

  return truncateString(
    name,
    textArea.width,
    fontWidthMap,
    truncationMode,
    'start',
  );
};
